module.exports = __webpack_public_path__ + "static/img/121.c54bde49.png";